import React, { useRef, useState } from 'react'
import './manager-element-list-item.styles.scss';
import ImageContainer from '../image-container/image-container.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faChartPie, faEllipsisV, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { stripHtml } from '@/utils/sanitize';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ElementDelete from '../element-delete/element-delete.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ElementDuplicate from '../element-duplicate/element-duplicate.component';
import UpgradeRequiredModal from '../upgrade-required-modal/upgrade-required-modal.component';
import ElementSaveToMyContent from '../element-savetomycontent/element-savetomycontent.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import ElementCopyToGames from '../element-copytogames/element-copytogames.component';
import useAnalytics from '@/utils/useAnalytics';
import { properCase } from '@/utils/properCase';

const ManagerElementListItem = ({
  gameElements,
  elementsFromDb,
  gameData,
  element,
  dropdown,
  dataPoint,
  setDropdown
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const membership = useSelector(state => state.userData.membership);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [copyLoading, setCopyLoading] = useState(false);
  const { trackEvent, trackException } = useAnalytics();
  const navigate = useNavigate();
  const location = useLocation();
  const approveRef = useRef();

  function checkMembership() {
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'create': true });
    if (res.disabled && res.disabledReason.includes('elements')) {
      const planRestrictions = membershipRestrictions[membership.membership];
      const message = `While using the ${planRestrictions.title}, ` +
        `you are only able to have ${planRestrictions.elementCount} active Game Elements per game.`;
      setShowUpgradeModal(message);
      return;
    }
    restoreInactive();
  }

  function restoreInactive() {
    if (location.pathname.includes('/preview/manager/')) {
      setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
      return;
    }
    setConfirmMessage('Are you sure you want to RESTORE this deleted Challenge? ' +
      'The Challenge will be restored with the same settings and data it had when it was deleted.');
    approveRef.current = () => {
      continueRestore();
    }

    async function continueRestore() {
      setLoading(true);
      let tempData = { ...element };
      const now = new Date().getTime();
      tempData.status = 'active';
      const res = await UseCloudFunction(
        'saveGameElement',
        {
          'gameId': element.gameId,
          'appId': userProfile.appId,
          'elementData': tempData,
          'userName': `${userProfile.fName} ${userProfile.lName}`,
          'action': 'Restored'
        }
      )
      console.log(res);
      if (res.error) {
        setAlertMessage('Something went wrong. Please try again later. Error: ' + res.error);
        setLoading(false);
        trackException(`${properCase(element.type)} Restore Error: ${res.error}`);
        return;
      }
      setAlertMessage(`${properCase(element.type)} restored successfully.`);
      setLoading(false);
      trackEvent(
        'game_element_restored',
        'Game Manager',
        `${properCase(element.type)} restored for game ${element.gameId}.`,
        null,
        membership
      );
    }
  }

  async function copyLink(path) {
    setCopyLoading(true);
    let text = `${window.location.origin}/live/${path}`;
    await navigator.clipboard.writeText(text);
    let timeout = setTimeout(() => {
      setCopyLoading(false);
      clearTimeout(timeout);
    }, 2000);
  }

  async function copyPath(path) {
    setCopyLoading(true);
    const el = document.getElementById(path + '_tooltip');
    if (el) {
      el.style.visibility = 'visible';
    }
    await navigator.clipboard.writeText(path);
    let timeout = setTimeout(() => {
      if (el) {
        el.style.visibility = 'hidden';
      }
      clearTimeout(timeout);
    }, 2000);
  }

  return (
    <div
      className={`manager-element-list-item g-list-item element-list-row ${screenSize}`}>
      <ImageContainer
        src={element.icon}
        alt={`${element.name} element icon`}
        className={`element-icon ${element.status !== 'active'
          ? 'disabled'
          : ''
          }`}
          preview={true} />
      <div className='element-name'>
        {element.name}
      </div>
      {
        (
          screenSize !== 'mobile' &&
          screenSize !== 'tablet'
        ) &&
        <>
          {/* <div className='meta'>
                    {
                        element.desc && element.desc.length > 50
                        ?
                        stripHtml(element.desc).substring(0,50) + '...'
                        :
                        (element.desc)
                        ?
                        stripHtml(element.desc)
                        :
                        null
                    }
                </div> */}
          <div className='meta element-purpose'>
            {dataPoint ? (typeof dataPoint === "string" ? properCase(dataPoint) : dataPoint) : null}
          </div>
        </>
      }
      <div className='buttons'>
        {/* <VisibilityButton element={c} /> */}
        {
          (element.status === 'active')
            ?
            <>
              {/* <button 
                        className='g-button med-btn' 
                        title='View badge data'
                        onClick={() => navigate(`/manage/${gameData.path}/elements/data/${element.path}`)}>
                        <FontAwesomeIcon icon={faChartPie} />
                    </button>
                    <button 
                        className='g-button med-btn' 
                        title='Edit this badge' 
                        onClick={() => navigate(`edit/${element.path}`)}  >
                        <FontAwesomeIcon icon={faPen} />
                    </button> */}
              <div
                className={`element-dropdown ${dropdown === element.id
                  ? 'active'
                  : ''
                  } ${element.type === 'leaderboard'
                    ? 'plus1'
                    : ''
                  }`} >
                <div className={`element-dropdown-menu`} onClick={() => setDropdown(null)}>
                  {
                    (element.type === 'leaderboard') &&
                    <>
                      <Link to={`/live/${element.path}`} target='_blank'>
                        <div className='element-menu-item'>
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                          View Leaderboard
                        </div>
                      </Link>
                      <div
                        className='element-menu-item'
                        onClick={() => copyLink(element.path)}>
                        <FontAwesomeIcon icon={faCopy} />
                        {
                          copyLoading
                            ?
                            'Copied!'
                            :
                            'Copy Link'
                        }
                      </div>
                    </>
                  }
                  <div
                    className='element-menu-item'
                    onClick={() => navigate(`edit/${element.path}`)}>
                    <FontAwesomeIcon icon={faPen} />
                    Edit
                  </div>
                  {
                    (element.type !== 'leaderboard') &&
                    <div
                      className='element-menu-item'
                      onClick={() => navigate(
                        location.pathname.includes('/preview/manager/')
                        ? `/preview/manager/${gameData.path}/elements/data/${element.path}`
                        : `/manage/${gameData.path}/elements/data/${element.path}`)}>
                      <FontAwesomeIcon icon={faChartPie} />
                      Usage Data
                    </div>
                  }
                  {/* <div className='element-menu-item'>
                                <FontAwesomeIcon icon={faCopy} />
                                Duplicate
                            </div> */}
                  <ElementDuplicate
                    gameElements={gameElements}
                    element={element}
                    style='menu-item' />
                  {
                    (
                      element.type !== 'leaderboard' &&
                      element.type !== 'collection' &&
                      element.opt_itemType !== 'prizePack'
                    ) &&
                    <ElementCopyToGames
                      gameElements={gameElements}
                      element={element}
                      style='menu-item' />
                  }
                  <ElementSaveToMyContent
                    gameData={gameData}
                    element={element}
                    style='menu-item' />
                  <div
                    className='element-menu-item g-tooltip'
                    onClick={() => copyPath(element.path)}>
                    <FontAwesomeIcon icon={faCopy} />
                    Copy ID
                    <div 
                      id={element.path + '_tooltip'} 
                      className='g-tooltip-text'>
                      Copied!
                    </div>
                  </div>
                  <ElementDelete
                    element={element}
                    style='menu-item' />
                </div>
              </div>
              <button
                className='g-button med-btn more-button'
                onClick={() => setDropdown(dropdown === element.id ? null : element.id)}>
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>

            </>
            :
            (loading)
              ?
              <button className='g-button med-btn'>
                <ThreeDotsLoader />
              </button>
              :
              <button
                className={`g-button ${screenSize === 'mobile' ? 'small-btn' : 'med-btn'}`}
                onClick={() => checkMembership()}>
                Restore
              </button>
        }
      </div>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        messge={alertMessage} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
        closeButton={true} />
    </div>
  )
}

export default ManagerElementListItem